import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=095070fd"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095070fd')) {
      api.createRecord('095070fd', component.options)
    } else {
      api.reload('095070fd', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=095070fd", function () {
      api.rerender('095070fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/Editor.vue"
export default component.exports